/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chartperiodlabel2Inputs */

const en_chartperiodlabel2 = /** @type {(inputs: Chartperiodlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period`)
};

const de_chartperiodlabel2 = /** @type {(inputs: Chartperiodlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

/**
* | output |
* | --- |
* | "Period" |
*
* @param {Chartperiodlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartperiodlabel2 = /** @type {((inputs?: Chartperiodlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartperiodlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartperiodlabel2(inputs)
	return de_chartperiodlabel2(inputs)
});
export { chartperiodlabel2 as "chartPeriodLabel" }